export const DOCUMENT_TYPE = {
  MEDICAL_CERTIFICATE: 'medical_certificate',
  PARENTAL_CONSENT: 'parental_consent',
  HEALTH_QUESTIONNAIRE: 'health_questionnaire',
  FFTRI_LICENSE: 'fftri_license',
};

export const DOCUMENT_STATUS = {
  NOT_VERIFIED: 'Not verified',
  VERIFIED: 'Verified',
  VERIFIED_MANUALLY: 'Verified Manually',
  IN_PROGRESS: 'In progress',
  PENDING: 'Pending',
  WAITING_DOCUMENT: 'waiting_document',
  WAITING_NEW_DOCUMENT: 'waiting_new_document',
  WAITING_CHECK: 'waiting_check',
  VALIDATED: 'validated',
  REFUSED: 'refused',
  CANCELLED: 'cancelled',
  CREATING_EXPECTED_ATTACHMENTS: 'creating_expected_attachments',
  NO_ATTACHMENT_EXPECTED: 'no_attachment_expected',
  WAITING_RACE_SETUP: 'waiting_race_setup',
  COMPLETED_ON_SITE: 'completed_on_site',
  NOT_IMPORTED: 'not_imported',
};

export const VERIFIED_STATES = [
  DOCUMENT_STATUS.VERIFIED,
  DOCUMENT_STATUS.VERIFIED_MANUALLY,
  DOCUMENT_STATUS.VALIDATED,
];
